const getNearestPowerOfTwo = (size) => {
    let iter = 2;

    while (iter < size) {
        iter <<= 1;
    }
    return iter;
};

const scaleToPowerOfTwo = ({ imageData }) => {
    const { width: srcWidth, height: srcHeight, data: srcData } = imageData;

    const dstWidth = getNearestPowerOfTwo(srcWidth);
    const dstHeight = getNearestPowerOfTwo(srcHeight);
    const dstData = new Uint8Array(dstWidth * dstHeight * 4);

    for (let iy = 0; iy < srcHeight; iy++) {
        for (let ix = 0; ix < srcWidth; ix++) {
            const srcIndex = (iy * srcWidth + ix) << 2;
            const dstIndex = (iy * dstWidth + ix) << 2;

            dstData[dstIndex] = srcData[srcIndex];
            dstData[dstIndex + 1] = srcData[srcIndex + 1];
            dstData[dstIndex + 2] = srcData[srcIndex + 2];
            dstData[dstIndex + 3] = srcData[srcIndex + 3];
        }
    }
    return {
        width: dstWidth,
        height: dstHeight,
        data: dstData,
    };
};

export default {
    getNearestPowerOfTwo,
    scaleToPowerOfTwo,
};
